import React, { useEffect, createElement } from 'react';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Promise } from './components/Promise';
import { WhatYouLearn } from './components/WhatYouLearn';
import { ForWho } from './components/ForWho';
import { OfferBox } from './components/OfferBox';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    document.title = 'Construye tu Website en 5 Minutos con IA — Sharon Tirado';
  }, []);
  useEffect(() => {
    // Meta Pixel Code
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1045235449792787');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = '<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1045235449792787&ev=PageView&noscript=1" />';
    document.head.appendChild(noscript);
    return () => {
      document.head.removeChild(script);
      document.head.removeChild(noscript);
    };
    // End Meta Pixel Code
  }, []);
  return <div className="w-full min-h-screen bg-white font-inter" data-id="element-0">
      <TopBar data-id="element-1" />
      <Hero data-id="element-2" />
      <Problem data-id="element-3" />
      <Promise data-id="element-4" />
      <WhatYouLearn data-id="element-5" />
      <ForWho data-id="element-6" />
      <OfferBox data-id="element-7" />
      <Guarantee data-id="element-8" />
      <FAQ data-id="element-9" />
      <FinalCTA data-id="element-10" />
      <Footer data-id="element-11" />
    </div>;
}